import { getLatestArrearsHalfRange } from '@koda/koda-utils/date';
import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const FOOTBALL_CONTENT_PATH = 'licenses.steps.businessInformation.forms.football';

export const footballSchema = BasicBusinessInformationSchema.extend({
  spectators: z
    .number({
      required_error: `${FOOTBALL_CONTENT_PATH}.spectators.validation.required`,
    })
    .int({ message: `${FOOTBALL_CONTENT_PATH}.spectators.validation.required` })
    .min(1, { message: `${FOOTBALL_CONTENT_PATH}.spectators.validation.required` }),
});

export type FootballForm = z.infer<typeof footballSchema>;

export const createFootballDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.Football,
});

export const toPayloadFootball = (form: FootballForm, wareNumber: number): GeneralPayload => {
  const { start, end } = getLatestArrearsHalfRange();
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(start).format('YYYY-MM-DD'),
    musicEndDate: dayjs(end).format('YYYY-MM-DD'),
    quantity: form.spectators,
  };
};
